export const SUBMIT_LOADING_LIST_LANDINGPAGE = "SUBMIT_LOADING_LIST_LANDINGPAGE"
export const UPDATE_LANDINGPAGE_LIST_REQUEST = "UPDATE_LANDINGPAGE_LIST_REQUEST"
export const CLEAR_LANDINGPAGE_REQUEST = "CLEAR_LANDINGPAGE_REQUEST"
export const UPDATE_PAGINATION_LIST_LANDINGPAGE = "UPDATE_PAGINATION_LIST_LANDINGPAGE"
export const UPDATE_LIST_DATA_LIST_LANDINGPAGE = "UPDATE_LIST_DATA_LIST_LANDINGPAGE"